import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import GpLogoLoader from "./common/GpLogoLoader";
import "../scss/style.scss";
import "../index.css";
import "react-toastify/dist/ReactToastify.css";

const Signing = lazy(() => import("./login/Signing"));
const ServiceOrderTable = lazy(() => import("./services-table"));
const SaleOrderTable = lazy(() => import("./sales-table"));
const CustomerRecep = lazy(() => import("./customer-detail/customer-recep"));
const CustomerSalesRecep = lazy(() =>
  import("./customer-detail/customer-sales-recep")
);
const OrderDetails = lazy(() => import("./orders-detail/order-details"));
const SalesOrderDetails = lazy(() =>
  import("./orders-detail/sales-order-details")
);
const AddCity = lazy(() => import("./login/select-city"));
const Topinfobar = lazy(() => import("./fixed-top"));
const AddGender = lazy(() => import("./login/add-gender"));
const NewPassword = lazy(() => import("./login/new-password"));
const ForgetPassowrd = lazy(() => import("./login/forget-password"));
const Servicess = lazy(() => import("./servicess"));
const Payment = lazy(() => import("./payment"));
const GuestUser = lazy(() => import("./guest-user-signup"));
const PinVerfication = lazy(() => import("./login/pin-verf"));
const AddRefferal = lazy(() => import("./login/add-refferal"));
const AlreadyExitNumber = lazy(() => import("./already-exit-number"));
const NotFound = lazy(() => import("./login/error-404"));

function App() {
  return (
    <div className="App" id="mainApp">
      <Suspense
        fallback={<GpLogoLoader visible mode="global" label="Loading" />}
      >
        <Switch>
          <Route exact path="/" component={Signing} />
          <Route
            path="/home/service-order-detail"
            component={ServiceOrderTable}
          />
          <Route path="/home/sale-order-detail" component={SaleOrderTable} />
          <Route path="/home/recipient" component={CustomerRecep} />
          <Route path="/home/sales-recipient" component={CustomerSalesRecep} />
          <Route path="/home/payment" component={Payment} />
          <Route path="/home/checkout" component={OrderDetails} />
          <Route path="/home/sales-checkout" component={SalesOrderDetails} />
          <Route path="/home/select-city" component={AddCity} />
          <Route path="/home/select-gender" component={AddGender} />
          <Route path="/home/servicess" component={Servicess} />
          <Route path="/home" render={() => <Topinfobar />} />
          <Route path="/verification" component={PinVerfication} />
          <Route path="/add-refferal" component={AddRefferal} />
          <Route path="/new-password" component={NewPassword} />
          <Route path="/forget-password" component={ForgetPassowrd} />
          <Route path="/guest-user" component={ForgetPassowrd} />
          <Route path="/guest-user-registration" component={GuestUser} />
          <Route path="/user-already-exist" component={AlreadyExitNumber} />
          <Route path="" component={NotFound} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
